<template>
  <div class="login notelogin">
    <div class="login-box">
      <router-link :to="this.$store.state.webCount.visitor_status == 0 ? '' : '/'">
        <img
          :src="this.$store.state.webCount.logo_wap"
          onerror="src='/static/images/login_logo.png'"
          class="logo"
        />
      </router-link>
    </div>
    <div class="login-cont">
      <div class="van-cell">
        <img src="./../../assets/img/iphone.svg" alt="" />
        <div class="van-cell__value">
          <input
            type="number"
            onkeypress="return( /[\d]/.test(String.fromCharCode(event.keyCode) ) )"
            placeholder="请输入手机号"
            v-model="mobile"
            class="van-field__control"
          />
        </div>
      </div>
      <div class="codebox van-cell">
        <img src="./../../assets/img/login-code.svg" alt="" />
        <div class="van-cell__value">
          <input
            type="number"
            placeholder="请输入验证码"
            v-model="code"
            class="van-field__control"
          />
        </div>
        <div class="van-field__button">
          <van-button slot="button" @click="getNvc()" class="get-code" :loading="codeLoading">
            获取验证码
          </van-button>
        </div>
      </div>
      <van-button class="loginbtn" @click="senData()" :loading="loading"> 登&#8194;录</van-button>

      <div class="login-text">
        <router-link v-if="this.$store.state.webCount.register_status == 1" to="/register">
          <div class="restBox">立即注册</div>
        </router-link>
      </div>
    </div>

    <div class="other-way" v-if="isShwoLogin" :style="{'justify-content': !isShowWeixin ? 'center' : 'space-between'}">
      <div class="login_wx" v-if="isShowWeixin">
        <img @click="wxlogin" src="./../../assets/img/login-wx.svg" alt />
        <span>微信登录</span>
      </div>

      <router-link to="/notelogin" tag="div" v-if="isShowZhangLogin">
        <div class="login_wx">
          <img src="./../../assets/img/login-zm.svg" alt />
          <span>账号密码登录</span>
        </div>
      </router-link>
    </div>
    <Nvc 
      ref="nverify" 
      :verify="verifyMethods"
    ></Nvc>
  </div>
</template>

<script>
import Nvc from "./components/nvc";
import md5 from "js-md5";
export default {
  name: "index",
  components: {
    Nvc
  },
  data() {
    return {
      loading: false,
      codeLoading: false,
      mobile: "",
      code: "",
      No: "",
      dd: "",
      includeMallWexin: ['hnyhxj', 'yongrongshop', 'geren'],
      includeMalltype: ["lipinduihuan", "xfj"],
      includeMallZhang: ['tkl', 'srys'],
      malltype: window.location.host.split(".")[0],
      nvcType: 1
    };
  },
  computed: {
    isShwoLogin() {
      var str = window.location.host;
      var malltype = str.split(".")[0];
      return !this.includeMalltype.includes(malltype);
    },
    isShowZhangLogin() {
      var str = window.location.host;
      var malltype = str.split(".")[0];
      return !this.includeMallZhang.includes(malltype);
    },
    isShowWeixin() {
      var str = window.location.host;
      var malltype = str.split(".")[0];
      console.log(33333, malltype)
      return !this.includeMallWexin.includes(malltype);
    }
  },
  methods: {
    getNvc: function() {
      const reg = /^[1][3456789][0-9]{9}$/;
      if(!reg.test(this.mobile)) {
        this.$toast("请输入正确的手机号码");
        return false;
      }
      this.nvcType = 1
      // 进行人机验证
      this.$refs.nverify.startVerify()
    },
    senData(nvc) {
      this.nvcType = 2
      this.$refs.nverify.startVerify()
    },
    wxlogin: function() {
      var mallid = localStorage.getItem("mallid");
      var root = process.env.LOGIN_URL;
      var backurl = window.location.origin + "/wxlogin";
      backurl = encodeURIComponent(backurl);
      window.location.href =
        root + "?reurl=" + backurl + "&id_example=" + mallid;
      // var ts = new Date($.ajax({async: false}).getResponseHeader("Date"));
      // var ts = new Date();
      //       ts = new Date(ts).getTime();
      //       ts =ts/1000
      //       var apiKey = '1106e4d408248208';
      //       var securityKey ='D5695EBCCF795D68';
      //       var sign =md5(md5('apiKey='+apiKey+'securityKey='+securityKey+'timeStamp='+ts));
      //       var str=window.location.host
      //       var mallid=localStorage.getItem("mallid");
      //       var host= window.location.host
      //       var root = process.env.LOGIN_URL
      //       window.location.href= root + '/user/wechat/login?id_example='+mallid+'&url=https://'+host+'&timeStamp='+ts+'&apiKey='+apiKey+'&sign='+sign;
    },
    verifyMethods(captchaVerifyParam) {
      return new Promise((resolve, reject) => {
        if(this.nvcType === 1) {
          var _this = this;
          var mallid = localStorage.getItem("mallid");
          if (this.codeLoading == false) {
            this.codeLoading = true;
            this.$api.post(
              "message",
              { id_example: mallid, phone: this.mobile, type: 2, captchaVerifyParam },
              res => {
                if (res.data.code == "100") {
                  this.No = res.data.data;
                  var time = 60;
                  _this.dd = setInterval(function() {
                    time--;
                    $(".notelogin .codebox .van-button").html(time + " s");
                    if (time <= 0) {
                      clearInterval(_this.dd);
                      _this.codeLoading = false;
                      $(".notelogin .codebox .van-button").html(
                        '<span class=\\"van-button__text\\">重新发送</span>'
                      );
                    }
                  }, 1000);
                  _this.codeLoading == false;
                  resolve(true)
                  this.$toast("发送成功请注意查收");
                } else if (
                  res.data.code == "200" ||
                  res.data.code == "400" ||
                  res.data.code == "600" ||
                  res.data.code == "900"
                ) {
                  resolve(false)
                  _this.codeLoading = false;
                } else if (res.data.code == "800") {
                  this.$toast("登录次数过多请稍后再试");
                  _this.codeLoading = false;
                  resolve(true)
                } else {
                  this.$toast(res.data.message);
                  _this.codeLoading = false;
                  resolve(true)
                }
              }
            );
          }
        } else if(this.nvcType === 2) {
          var mallid = localStorage.getItem("mallid");
          var code = this.No + "_" + this.code;
          this.loading = true;
          this.$api.post(
            "user/login/phone",
            { id_example: mallid, type: 1, phone: this.mobile, code: code, captchaVerifyParam },
            res => {
              if (res.data.code == "100") {
                localStorage.setItem("BLHuser", res.data.data.token_user);
                var url = localStorage.getItem("routerUrl");
                this.$store.commit("userInfo");
                resolve(true)
                if (url != undefined && url != null && url != "") {
                  this.$router.push({ name: url, params: { isAuth: true } }); //跳到路由拦截前的地址
                } else {
                  this.$router.push({ name: "Home", params: { isAuth: true } });
                }
              } else if (
                res.data.code == "200" ||
                res.data.code == "400" ||
                res.data.code == "600" ||
                res.data.code == "900"
              ) {
                resolve(false)
              } else {
                resolve(true)
                this.$toast(res.data.message);
              }
              this.loading = false;
            }
          );
        }
      })
    }
  },
  mounted() {},
  destroyed: function() {
    clearInterval(this.dd);
    $(".notelogin .codebox .van-button").html(
      '<span class=\\"van-button__text\\">获取验证码</span>'
    );
  }
};
</script>

<style lang="less" scoped>
.login {
  width: 100%;
  min-height: 100vh;
  background-image: url("./../../assets/img/login-bg.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;

  .login-box {
    text-align: center;
    padding-top: 0.6rem;

    .logo {
      width: auto;
      min-width: 1.84rem;
      max-width: 1.84rem;
    }
  }

  .login-cont {
    margin-top: 0.84rem;
    box-sizing: border-box;
    padding: 0 0.6rem;

    .van-cell {
      padding: 0.46rem 0 !important;
      border-bottom: 0.01rem solid rgba(26, 26, 26, 0.08);
      background: transparent !important;
      display: flex;
      align-items: center;

      img {
        width: 0.48rem;
        height: 0.48rem;
      }

      .van-cell__value {
        padding-left: 0.2rem;

        .van-field__control {
          &::placeholder {
            color: rgba(38, 38, 38, 0.5);
          }
        }
      }

      .van-field__button {
        .get-code {
          min-width: 1.68rem;
          height: 0.52rem;
          background: #fe5c42;
          border-radius: 0.08rem;
          color: #fff;
          border: none;
        }
      }
    }

    .loginbtn {
      width: 100%;
      height: 0.96rem;
      background: linear-gradient(111deg, #e23130 0%, #e23130 100%);
      border-radius: 0.48rem;
      font-size: 0.3rem;
      font-weight: 500;
      color: #ffffff;
      line-height: 0.42rem;
      margin-top: 1.3rem;
      border: none;
    }

    .login-text {
      margin-top: 0.2rem;
      display: flex;
      align-items: center;
      justify-content: flex-end;

      .restBox {
        width: 1.12rem;
        height: 0.4rem;
        font-size: 0.28rem;
        font-weight: 500;
        color: #025bff;
        line-height: 0.4rem;
      }
    }
  }

  .other-way {
    box-sizing: border-box;
    padding: 1rem 2rem 0 2rem;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .login_wx {
      display: flex;
      flex-direction: column;
      align-items: center;

      img {
        width: 0.88rem;
        height: 0.88rem;
      }

      span {
        margin-top: 0.2rem;
        font-size: 0.24rem;
        font-weight: 400;
        color: #929292;
        line-height: 0.42rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/login/notelogin.vue